export default __webpack_public_path__ + "static/media/9.5a1c7988.jpg";